export default __webpack_public_path__ + "static/media/icons8-diners-club.47a65f3b.svg";